import { render, staticRenderFns } from "./StudentInfo.vue?vue&type=template&id=1356269a&scoped=true"
import script from "./StudentInfo.vue?vue&type=script&lang=ts"
export * from "./StudentInfo.vue?vue&type=script&lang=ts"
import style0 from "./StudentInfo.vue?vue&type=style&index=0&id=1356269a&prod&lang=scss&scoped=true"
import style1 from "./StudentInfo.vue?vue&type=style&index=1&id=1356269a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1356269a",
  null
  
)

export default component.exports